<div class="p-0 d-flex flex-column flex-grow-1 h-100" style="min-height: 300px">

  <div class="col-12 d-flex flex-column  border-bottom border-1">

    <input type="file" multiple webkitdirectory class="d-none" #directoryInput (change)="fileSelected($event)"/>
    <input type="file" multiple class="d-none" #fileInput (change)="fileSelected($event)"/>

    <nav class="navbar navbar-expand navbar-dark bg-dark">
      <div class="container-fluid">
        <div id="navbarColor02" class="collapse navbar-collapse">
          <ul class="navbar-nav me-auto">
            <li class="nav-item" (click)="uploadFile()">
                <span href="#" class="nav-link pointer">
                <i class="fa fa-file-upload  me-1"></i>
               </span>
            </li>
          </ul>

          <div class="btn-group">
            <button
              type="button" class="btn btn-sm btn-secondary my-2 my-sm-0"
              (click)="reload()"
            ><i class="fa fa-refresh"></i></button>
          </div>
        </div>
      </div>
    </nav>
  </div>

  <div class="col-12 d-flex flex-column bg-white flex-grow-1 ">


    <div class="d-flex flex-column h-100">
      <table class="table table-sm table-striped  mb-0 border-top w-100">
        <thead>
        <tr>
          <th scope="col" class="text-start">Name</th>
          <th scope="col" class="text-end">Size</th>
          <th scope="col" class="text-end">Date Modified</th>
          <th scope="col" class="text-end">Date Created</th>
        </tr>
        </thead>

        <tbody class="overflow-x-scroll" style="max-height: 100px">
        <tr
          class="pointer"
          *ngFor="let attachment of privateAttachments; let index = index"
          [contextMenu]="fileContextMenu"
          (contextmenu)="fileContextMenu.open"
          [contextMenuValue]="attachment"
        >
          <td class="text-start">
            @if (attachment.image_height !== null) {
              <i class="fa fa-image me-1"></i>
            } @else {
              <i class="fa fa-file me-1"></i>
            }

            {{ attachment.name }}
          </td>

          <td class="text-end">
            <ng-container *ngIf="attachment.size"> {{ attachment.size | filesize }}</ng-container>
          </td>
          <td class="text-end">{{ attachment.updated_at | dfnsParseIso| formatInTimeZone: dfnsLocale: 'mediumDate' }}
          </td>
          <td class="text-end">{{ attachment.created_at | dfnsParseIso| formatInTimeZone: dfnsLocale: 'mediumDate' }}
          </td>
        </tr>
        </tbody>
      </table>
      <div [contextMenu]="backgroundContextMenu" (contextmenu)="backgroundContextMenu.open" class="d-flex flex-grow-1"></div>
    </div>

  </div>

  <div class="row d-flex flex-grow-0 g-0 p-0 m-0 border-top border-1 bg-white">
    <div class="col-6 p-3">
      {{ privateAttachments.length | number }} Items
    </div>

    <div class="col-6 p-3">

      <ng-container *ngIf="(privateUploadService.uploadSummary | async)?.files?? 0 > 0">
        Uploading: {{ (privateUploadService.uploadSummary | async)?.files }} /
        {{ (privateUploadService.uploadSummary | async)?.progress | number:'0.0' }}%
      </ng-container>

      <div class="position-absolute bottom-0 end-0 m-3 w-25">

        <ng-container
          *ngFor="let upload of (privateUploadService.currentUploads.value | keyvalue);let index = index"
        >
          <div class="small rounded-2 p-1  border-bottom border-1 mb-1"
               [class.bg-gray-400]="!upload.value.error"
               [class.bg-red-100]="upload.value.error"
          >
                <span class="text-dark text-truncate d-block w-100 mt-0 pb-1 ">
                  <button
                    type="button" class="btn-close" (click)="privateUploadService.cancel(upload.value)"
                  ><i class="fa fa-times"></i></button>

                  {{ upload.value.file.name }} ({{ upload.value.file.size | filesize }})
                </span>

            <span class="d-block p-1" *ngIf="upload.value.error">
                Error:
                <ng-container *ngIf="upload.value.errorCode === 409">
                  File with this name already exists
                </ng-container>
                <ng-container *ngIf="upload.value.errorMessage">
                  {{ upload.value.errorMessage }}
                </ng-container>

                <br>
                <button type="button" class="btn btn-sm btn-secondary"
                        (click)="privateUploadService.retry(upload.value)"
                        *ngIf="upload.value.error">
                <i class="fa fa-repeat"></i> Retry
                </button>
                <button type="button" class="btn btn-sm btn-danger" (click)="privateUploadService.cancel(upload.value)"
                        *ngIf="upload.value.error">
                  <i class="fa fa-times"></i> Cancel
                </button>
              </span>


            <div class="progress" *ngIf="!upload.value.error">

              <div role="progressbar"
                   [style.width.%]="upload.value.progress"
                   class="progress-bar"
                   [class.bg-success]="upload.value.finished"

              ></div>
            </div>
          </div>
        </ng-container>
      </div>


    </div>

  </div>

</div>

<context-menu #fileContextMenu>
  <ng-template
    contextMenuItem
    (execute)="executeAttachmentContextMenu(FileBrowserContextMenuActionEnum.DOWNLOAD, $event)"
  ><i class="fa fa-download"></i> Download</ng-template>

  <ng-template
    contextMenuItem
    (execute)="executeAttachmentContextMenu(FileBrowserContextMenuActionEnum.RENAME, $event)"
  ><i class="fa fa-edit"></i> Rename</ng-template>

  <ng-template
    contextMenuItem
    (execute)="executeAttachmentContextMenu(FileBrowserContextMenuActionEnum.DELETE, $event)"
  ><i class="fa fa-trash"></i> Delete</ng-template>

    <ng-template contextMenuItem [divider]="true"></ng-template>

    <ng-template
      contextMenuItem
      (execute)="executeAttachmentContextMenu(FileBrowserContextMenuActionEnum.UPLOAD_FILE, $event)"
    ><i class="fa fa-cloud-upload"></i> Upload File</ng-template>

    <ng-template
      contextMenuItem
      (execute)="executeAttachmentContextMenu(FileBrowserContextMenuActionEnum.RELOAD, $event)"
    ><i class="fa fa-refresh"></i> Refresh</ng-template>
  </context-menu>

  <context-menu #backgroundContextMenu>
    <ng-template
      contextMenuItem
      (execute)="executeAttachmentContextMenu(FileBrowserContextMenuActionEnum.UPLOAD_FILE, $event)"
    ><i class="fa fa-cloud-upload"></i> Upload File</ng-template>

    <ng-template
      contextMenuItem
      (execute)="executeAttachmentContextMenu(FileBrowserContextMenuActionEnum.RELOAD, $event)"
    ><i class="fa fa-refresh"></i> Refresh</ng-template>
</context-menu>

<ng-template #renameAttachmentModalTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Rename</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="renameAttachmentModal?.hide()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <form (submit)="renameAttachment()" [formGroup]=renameAttachmentForm>
      <app-form-group
        [autofocus]="true"
        [name]="'name'"
        [formControl]="renameAttachmentForm.controls.name">
      </app-form-group>

    </form>
  </div>
  <div class="modal-footer">

    <button  type="button" class="btn btn-outline-danger" (click)="renameAttachmentModal?.hide()">Cancel</button>
    <button  type="button" class="btn btn-primary" (click)="renameAttachment()">Save</button>
  </div>
</ng-template>
